import { Link } from 'react-router-dom';
import { Sensor } from '../interfaces';

export interface AlarmedSensorProps {
  id?: string;
  cols?: string;
  sensor: Sensor;
  showSettings?: boolean;
  onKillAlarmClicked?: (sensorId: string) => void;
}

const killAlarmClickHandler = (props: AlarmedSensorProps) => {
  if (props.onKillAlarmClicked) {
    props.onKillAlarmClicked(props.sensor._id);
  }
}

const SensorItem = (props: AlarmedSensorProps) => {
  const { sensor, showSettings, cols } = props;
  return (
    <div className={cols ?? 'col-lg-4 col-md-6 col-12'}>
      <div className="sensor-item">
        <div className="item-content">
          <i className="fad fa-sensor-alert sensor-icon"></i>
          <span className="sensor-name">{sensor._id} - {sensor.name ?? 'No Name'}</span>
        </div>
        <hr />
        <div className="buttons-wrapper">
          {/* <Link to={'/dashboard/sensor-alarms/' + sensor._id}>
            <button className="btn btn-show-alert">
              مشاهده خطاها
            </button>
          </Link> */}
          <Link className="btn btn-show-graph" to={'/dashboard/graph/' + sensor._id}>
            <i className="fad fa-chart-bar"></i>
            <span>نمایش گراف</span>
          </Link>
          {(!showSettings) ? '' : (
            <Link className="btn btn-show-settings" to={'/dashboard/sensors/edit/' + sensor._id}>
              <i className="fad fa-cog"></i>
              <span>تنظیمات</span>
            </Link>
          )}
          <button
            className="btn btn-kill-alert"
            onClick={killAlarmClickHandler.bind(this, props)}>
            <i className="fad fa-exclamation-triangle"></i>
            <span>قطع هشدار</span>
          </button>
        </div>
        <hr />
        <Link
          className="btn btn-show-details"
          to={'/dashboard/sensor-alarms/' + sensor._id}>
          <span>نمایش جزئیات</span>
        </Link>
      </div>
    </div>
  );
}

export default SensorItem;
